import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { HeroTestimonials } from './components/HeroTestimonials';
import { Problems } from './components/Problems';
import { ProductIntro } from './components/ProductIntro';
import { SixTomos } from './components/SixTomos';
import { SixBonos } from './components/SixBonos';
import { PricingUrgency } from './components/PricingUrgency';
import { PackPlusExtras } from './components/PackPlusExtras';
import { LongTestimonials } from './components/LongTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { ComparisonTable } from './components/ComparisonTable';
import { FinalPricing } from './components/FinalPricing';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen flex flex-col overflow-x-hidden" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProofBar data-id="element-3" />
      <HeroTestimonials data-id="element-4" />
      <Problems data-id="element-5" />
      <ProductIntro data-id="element-6" />
      <SixTomos data-id="element-7" />
      <SixBonos data-id="element-8" />
      <PricingUrgency data-id="element-9" />
      <PackPlusExtras data-id="element-10" />
      <LongTestimonials data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <ComparisonTable data-id="element-14" />
      <FinalPricing data-id="element-15" />
      <Footer data-id="element-16" />
      <StickyCTA data-id="element-17" />
    </div>;
}